import { Group, Layout, Page, Tree } from "@/comn/components";
import { useNavigate, useParams } from "react-router-dom";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useModal, useResource, useToast, usePage } from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { BASE, URLS, APIS, SF_REGN_CD_INFO } from "@/tz/go/egaz/osci/ptl/cd/regncd/services/OsciRegnCdService";

/*
 * Region Code Modification
 * !== 지역 코드 수정 ==!
 */
export const OSCI0109014S = () => {
    useResource({
        defaultSchema: [
            { area: "cntyCd" },
            { area: "comnCd", comnCd: "OSC0091" },
            { area: "comnCd", comnCd: "OSC0101" }, // 활성화 여부 코드
        ],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { regnCd } = useParams();
    const modal = useModal();
    const toast = useToast();

    const form = {
        regnCdInfo: useForm({
            defaultSchema: SF_REGN_CD_INFO,
        }),
    };

    const fetch = {
        getRegnCdInfo: useFetch({
            api: () => APIS.getRegnCdInfo(regnCd),
            onSuccess: (data: any) => {
                // 데이터가 없을 경우
                if (!data.regnCdInfo.content) {
                    modal.openModal({ content: "msg.osc.00050" }); // No data found. !== 해당 데이터가 없습니다. ==!

                    navigate(`${URLS.osci0109012q}?menuId=${menuId}`);
                    return;
                }
                form.regnCdInfo.setValues(data.regnCdInfo.content);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00035" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
        updateRegnCdInfo: useFetch({
            api: (info: any) => APIS.updateRegnCdInfo(info),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.osc.00070" }); // Successfully updated. !== 정상적으로 수정되었습니다.==!
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00039" }), // Failed to update. !== 수정이 실패하였습니다.==!
        }),
        deleteRegnCdInfo: useFetch({
            api: (info: any) => APIS.deleteRegnCdInfo(info),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00071", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    close: false,
                    onConfirm: () => {
                        navigate(`${URLS.osci0109012q}?menuId=${menuId}`);
                    },
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00040" }), // Failed to remove. !== 삭제가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onListBtnClick: () => navigate(`${URLS.osci0109012q}?menuId=${menuId}`),
        onUpdateBtnClick: form.regnCdInfo.handleSubmit(
            () => {
                modal.openModal({
                    content: "msg.osc.00064", // Confirm update? !== 수정하시겠습니까? ==!
                    onConfirm: () => fetch.updateRegnCdInfo.fetch(form.regnCdInfo.getValues()),
                });
            },
            () => toast.showToast({ type: "warning", content: "msg.osc.00003" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
        ),
        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.osc.00062", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () =>
                    fetch.deleteRegnCdInfo.fetch(
                        form.regnCdInfo.getValue("regnCd") +
                            "-" +
                            form.regnCdInfo.getValue("cntyCd") +
                            "-" +
                            form.regnCdInfo.getValue("regnTpCd"),
                    ),
            });
        },
    };

    useEffect(() => {
        fetch.getRegnCdInfo.fetch();
        form.regnCdInfo.setSchema("regnCd", { edit: false });
        form.regnCdInfo.setSchema("cntyCd", { edit: false });
        form.regnCdInfo.setSchema("regnTpCd", { edit: false });
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.regnCd} />
                            <Group.Control {...form.regnCdInfo.schema.regnTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.cntyCd} />
                            <Group.Control {...form.regnCdInfo.schema.cstmOfceCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.regnNmEn} />
                            <Group.Control {...form.regnCdInfo.schema.regnNmKo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.regnNmTz} />
                            <Group.Control {...form.regnCdInfo.schema.portYn} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"edit"} onClick={handler.onUpdateBtnClick} />
                    <Layout.Button role={"delete"} onClick={handler.onDeleteBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
